export const profile = {
communicationPrefs: {
screenTitle: "Préférences de communication",
screenSubtitle: "Choisissez le sujet pour lequel nous vous contactons. Les notifications requises sont nécessaires pour que le service fonctionne en toute sécurité ; les options facultatives dépendent entièrement de vous.",
requiredSectionTitle: "Obligatoire",
requiredSectionHint: "Envoyé par e-mail et/ou push. Nécessaire pour utiliser AssetWRX en toute sécurité.",
requiredBadge: "Obligatoire",
optionalSectionTitle: "Facultatif",
optionalSectionHintLoading: "Chargement de vos préférences…",
optionalSectionHint: "Activez ou désactivez chacun à tout moment. Le retrait prend effet immédiatement et est enregistré dans votre historique de consentement.",
alwaysOnBadge: "Toujours activé",
alwaysOnHintLegit: "Toujours activé (nécessaire au bon fonctionnement du service)",
marketingEmailTitle: "Mises à jour des produits, conseils et promotions — e-mail",
marketingEmailBody: "E-mails occasionnels sur les nouvelles fonctionnalités, les modèles de flux de travail et les offres. Désactivé par défaut.",
marketingPushTitle: "Mises à jour des produits, conseils et promotions — push",
marketingPushBody: "Notifications push pour les lancements et offres majeurs. Désactivé par défaut.",
analyticsTitle: "Analyses de produits",
analyticsBody: "Aidez-nous à comprendre comment AssetWRX est utilisé afin de l’améliorer : écrans utilisés, appuis et enregistrements de session où tout ce que vous saisissez est masqué.",
crashReportingTitle: "Rapports d'incidents et de stabilité",
crashReportingBody: "Rapports de plantage sans vos informations personnelles. Toujours activés, car nous en avons besoin pour qu'AssetWRX fonctionne.",
serviceNotifTitle: "Notifications de service",
serviceNotifBody: "Alertes d'incident, reçus de facturation et modifications de compte.",
securityNotifTitle: "Notifications de sécurité",
securityNotifBody: "Alertes de connexion, changements de mot de passe, avertissements d'activité suspecte.",
inspectionRemindersTitle: "Rappels d’inspection",
inspectionRemindersBody: "Rappels pour les inspections planifiées dont vous êtes propriétaire.",
confirmEmailError: "Impossible d'envoyer l'e-mail de confirmation. Essayer à nouveau.",
alreadySubscribed: "Vous êtes déjà abonné.",
confirmationSent: "Vérifiez votre courrier électronique - nous avons envoyé un lien de confirmation. Cliquez dessus dans les 24 heures pour vous abonner.",
updatedFeedback: "{{title}} mis à jour.",
saveError: "Impossible d'enregistrer vos préférences. Essayer à nouveau.",
pendingHint: "En attente — vérifiez votre e-mail pour le lien de confirmation (valable 24 h).",
deliveryPausedHint: "L’abonnement a été suspendu en raison de problèmes d’envoi. Désactivez puis réactivez pour réessayer.",
},
consentHistory: {
loading: "Chargement…",
errorTitle: "Erreur",
emptyTitle: "Aucun événement de consentement pour l'instant",
emptyBody: "Une fois que vous acceptez ou modifiez une préférence, elle apparaîtra ici.",
screenTitle: "Historique des consentements",
screenSubtitle: "Chaque politique acceptée et chaque choix marketing ou analytique donné ou retiré. Les entrées sont conservées telles quelles et ne peuvent pas être modifiées. Les réglages d'alertes du téléphone ne sont pas des consentements et se trouvent dans Préférences.",
labelTerms: "Conditions d’utilisation",
labelPrivacy: "Politique de confidentialité",
labelMarketingEmail: "E-mail marketing",
labelMarketingPush: "Notifications push marketing",
labelAnalytics: "Analyses de produits",
labelCrashReporting: "Rapports de plantage",
labelCookieAnalytics: "Cookies d’analyse",
labelCookieMarketing: "Cookies marketing",
labelLocationSharing: "Partage de position pendant le travail",
actionAccepted: "accepté",
actionWithdrawn: "retiré",
actionUpdated: "mis à jour",
detailSource: "Donné via",
detailReason: "Motif",
sourcePhonePrompt: "La question sur l’analyse dans l’application",
sourceSignup: "Inscription",
sourceCookieBanner: "Bannière de cookies",
sourceSignupCatchup: "Inscription (enregistrée plus tard)",
device: {
ios: "iPhone ou iPad",
android: "Appareil Android",
web: "Navigateur web",
unknown: "Appareil inconnu",
},
},
exportData: {
whatYoullReceiveTitle: "Ce que vous recevrez",
itemProfile: "Votre profil et paramètres de compte",
itemAssets: "Tous les actifs, inspections et interventions que vous possédez",
itemContacts: "Contacts et appartenances aux équipes",
itemRequests: "Les demandes que vous avez créées et tous leurs messages",
itemReports: "Rapports et devis partagés avec vous, avec vos réponses",
itemConsent: "Votre historique complet de consentement et d'audit",
itemDeletionLog: "Entrées du journal de suppression de compte (le cas échéant)",
itemPriorExports: "Une copie de toutes demandes d’exportation antérieures",
footnote: "Chaque lien de téléchargement fonctionne 7 jours et uniquement pour vous.",
preparing: "Préparation de votre export…",
requestButton: "Demander mon export de données",
recentRequestsTitle: "Demandes récentes",
loading: "Chargement…",
noExportsYet: "Aucune exportation pour l’instant — demandez-en une ci-dessus pour commencer.",
statusQueued: "En file d'attente",
statusProcessing: "En cours de traitement",
statusReady: "Prêt",
statusFailed: "Échec",
statusExpired: "Expiré",
requestedAt: "demandé {{date}}",
linkExpires: "Le lien expire {{date}}",
linkExpiresSoon: "Expire dans les 24 heures · Le lien expire le {{date}}",
downloadButton: "Télécharger",
readyFeedback: "Votre export est prêt. Appuyez sur « Télécharger » ci-dessous pour l'enregistrer.",
screenTitle: "Exporter mes données",
screenSubtitle: "Vous pouvez télécharger à tout moment une copie des données de votre compte AssetWRX. Elle se présente sous la forme d'un fichier de données que d'autres logiciels peuvent ouvrir.",
},
privacyDataHub: {
screenTitle: "Confidentialité et données",
screenSubtitle: "Téléchargez vos données, choisissez ce que nous vous envoyons par e-mail ou supprimez votre compte. Chaque changement est consigné dans votre historique des consentements.",
expandLabel: "Ouvrir",
collapseLabel: "Fermer",
itemPrivacyTitle: "Politique de confidentialité",
itemPrivacyBody: "Comment nous collectons, utilisons et protégeons vos données.",
itemTermsTitle: "Conditions d’utilisation",
itemTermsBody: "L'accord qui régit votre utilisation de AssetWRX.",
itemCookiesTitle: "Politique relative aux cookies",
itemCookiesBody: "Quels cookies et stockages similaires nous utilisons, et comment les contrôler.",
itemSubprocessorsTitle: "Sous-traitants ultérieurs",
itemSubprocessorsBody: "Les tiers que nous engageons pour traiter les données, et où ils opèrent.",
itemDpaTitle: "Accord de traitement des données",
itemDpaBody: "Comment nous traitons votre contenu pour votre compte.",
itemMarketingTitle: "Politique de consentement marketing",
itemMarketingBody: "Comment nous obtenons, prouvons et respectons votre consentement.",
itemExportTitle: "Exporter mes données",
itemExportBody: "Téléchargez une copie de tout ce que contient votre compte.",
itemCommsTitle: "Préférences de communication",
itemCommsBody: "Choisissez les mises à jour et conseils facultatifs que vous recevez, ainsi que les canaux utilisés.",
itemHistoryTitle: "Historique des consentements",
itemHistoryBody: "Chaque politique que vous avez acceptée et chaque consentement marketing ou analytique que vous avez donné ou retiré.",
itemAiTitle: "Fonctions d’IA",
itemAiBody: "Si AssetWRX peut envoyer des photos et du texte à Google (Gemini) lorsque vous utilisez une fonction d’IA sur cet appareil.",
aiAllowed: "Autorisé sur cet appareil. Google traite ce qu’envoie une fonction d’IA et ne l’utilise pas pour entraîner ses modèles.",
aiNotAllowed: "Non autorisé. Les fonctions d’IA demandent avant d’envoyer quoi que ce soit.",
aiWithdraw: "Ne plus utiliser l’IA sur cet appareil",
aiAllow: "Autoriser les fonctions d’IA",
itemDeletionPolicyTitle: "Politique de suppression des données",
itemDeletionPolicyBody: "Comment fonctionne la suppression, ce qui est conservé et la fenêtre de récupération de 30 jours.",
itemDeleteTitle: "Supprimer le compte",
itemDeleteBody: "Supprimez de manière irréversible votre compte et vos données. Une fenêtre de récupération de 30 jours s'applique.",
},
security: {
  twoFactorSection: "Connexion à deux facteurs",
  signIn: {
    cancel: "Annuler",
    biometricOffHint: "Désactivé. La connexion enregistrée sur ce téléphone est oubliée.",
    biometricOnHint: "Activé. {{method}} vous connecte sur ce téléphone (après une connexion avec votre mot de passe).",
    biometricTitle: "Se connecter avec {{method}} sur ce téléphone",
    setPasswordFailed: "Le lien n'a pas été envoyé. Vérifiez votre connexion et réessayez.",
    setPasswordSent: "Nous avons envoyé un lien à {{email}}. Ouvrez-le pour définir votre mot de passe. Vous pouvez toujours vous connecter avec Google, Apple ou Microsoft.",
    passwordChanged: "Votre mot de passe est changé. Utilisez-le à votre prochaine connexion.",
    passwordFailed: "Votre mot de passe n'a pas été changé. Réessayez.",
    passwordMismatch: "Les deux mots de passe sont différents. Saisissez deux fois le même.",
    passwordRequired: "Saisissez un nouveau mot de passe.",
    passwordSave: "Enregistrer le mot de passe",
    passwordConfirmLabel: "Saisissez-le à nouveau",
    passwordNewLabel: "Nouveau mot de passe",
    setPassword: "Définir un mot de passe",
    passwordChange: "Changer le mot de passe",
    passwordNone: "Vous vous connectez avec Google, Apple ou Microsoft : vous n'avez donc pas encore de mot de passe.",
    passwordSet: "Vous vous connectez avec un mot de passe.",
    passwordTitle: "Mot de passe",
    emailSent: "Nous avons envoyé un lien à votre nouvelle adresse, {{email}}. Ouvrez-le pour terminer le changement. D'ici là, vous continuez à vous connecter avec {{current}}.",
    emailFailed: "Le lien n'a pas été envoyé. Vérifiez votre connexion et réessayez.",
    emailTaken: "Un autre compte utilise déjà cette adresse. Utilisez-en une autre.",
    emailSame: "C'est déjà votre adresse e-mail.",
    emailInvalid: "Saisissez une adresse e-mail comme nom@entreprise.com.",
    emailSend: "Envoyer le lien",
    emailNewHelper: "Nous envoyons un lien à la nouvelle adresse. Le changement se fait quand vous l'ouvrez.",
    emailNewLabel: "Nouvelle adresse e-mail",
    emailPending: "En attente de l'ouverture du lien envoyé à {{email}}.",
    emailChange: "Changer l'e-mail",
    emailTitle: "E-mail",
    sectionTitle: "Comment vous vous connectez",
  },
title: "Sécurité",
removeLastWarning: "Ceci est votre seul authentifiant. Deux facteurs sont requis, il vous sera donc demandé d’en configurer un à nouveau immédiatement.",
removeBody: "Supprimer cet authentificateur ? Vous pourrez l'ajouter à nouveau plus tard.",
removeTitle: "Supprimer l'authentificateur",
cancel: "Annuler",
remove: "Supprimer",
removeFailedTitle: "Impossible de supprimer",
removeFailedBody: "Veuillez réessayer.",
statusOn: "La connexion à deux facteurs est activée",
statusOff: "La connexion à deux facteurs est désactivée",
statusSub: "Protège votre compte avec un code d'une application d'authentification (Microsoft Authenticator, Google Authenticator, Authy).",
methods: "Vos authentifiants",
loading: "Chargement…",
none: "Aucun authentificateur configuré pour l'instant.",
authenticator: "Authentificateur",
added: "Ajouté",
removeA11y: "Supprimer l'authentificateur",
add: "Ajouter un authentificateur",
addBackup: "Ajouter un authentificateur de sauvegarde",
},
diagnosticsScreen: {
  title: "Diagnostics",
  subtitle: "Ce que le support doit savoir. Rien ici n’est secret.",
  sectionBuild: "Build",
  sectionWorkspace: "Espace de travail",
  sectionConnectivity: "Connectivité",
  sectionServices: "Services",
  appVersion: "Version de l’application",
  build: "Build",
  commit: "Commit Git",
  runtime: "Version du runtime",
  updateChannel: "Canal de mise à jour",
  platform: "Plateforme",
  environment: "Environnement",
  backend: "Backend",
  workspace: "Espace de travail",
  role: "Rôle",
  plan: "Forfait",
  capabilities: "Fonctionnalités activées",
  connectivity: "Connexion",
  online: "En ligne",
  offline: "Hors ligne",
  outbox: "Modifications en attente d’envoi",
  lastSync: "Dernier envoi",
  sentry: "Rapport de plantage",
  sentryOn: "Activé · version {{release}}",
  sentryOff: "Non configuré",
  posthog: "Analyse produit",
  posthogOn: "Activée (consentement donné)",
  posthogOff: "Désactivée (sans consentement)",
  apiHealth: "État de l’API",
  apiChecking: "Vérification…",
  apiOk: "OK · {{latency}} ms · migrations {{head}}",
  apiFail: "Injoignable",
  push: "Notifications push",
  pushRegistered: "Enregistré auprès du service push Expo",
  pushNotRegistered: "Non enregistré sur cet appareil (nécessite un build avec les identifiants push et l'autorisation accordée)",
  pushUnsupported: "Non disponible sur cette plateforme",
  copy: "Copier les diagnostics",
  copied: "Copié",
  never: "Jamais",
  unknown: "Inconnu",
  personal: "Personnel",
  none: "Aucune",
  web: "Web",
},
whatsNew: {
  eyebrow: "Nouveautés d'AssetWRX",
  gotIt: "Compris",
  seeAll: "Voir toutes les mises à jour",
  sectionTitle: "Nouveautés",
  empty: "Aucune note de version pour l'instant.",
  dateLine: "Version {{version}} du {{date}}",
},
aboutScreen: {
  product: "AssetWRX {{version}}",
  title: "À propos",
  subtitle: "La version d'AssetWRX sur cet appareil. Copiez-la lorsque vous contactez le support.",
  build: "Build {{build}}",
  webBuild: "Web",
  runtime: "Environnement d’exécution {{runtime}}",
  channel: "Canal {{channel}}",
  environment: "Environnement {{environment}}",
  update: "Mise à jour {{update}}",
  copy: "Copier",
  copied: "Copié",
},
helpScreen: {
  contactSupportSubtitle: "Posez votre question à une personne. Ouvre notre page d'assistance dans votre navigateur.",
  contactSupportTitle: "Contacter l'assistance AssetWRX",
subtitle: "AssetWRX vous aide à gérer les actifs, réaliser des inspections et suivre les interventions de réparation.",
coreWorkflowTitle: "Flux de travail principal",
coreWorkflowBody: "• Ajouter des actifs (véhicules, équipements, propriétés)\n• Démarrer une inspection avec une liste de contrôle\n• Partager le rapport pour approbation du client\n• Convertir les réparations approuvées en interventions\n• Attribuer des interventions aux membres de l'équipe ou aux entrepreneurs",
toursTitle: "Visites guidées",
toursSubtitle: "Parcours pas à pas dans l’application : enregistrer un actif, réaliser une inspection, configurer la maintenance.",
openToursA11y: "Ouvrir les visites guidées",
guideTitle: "Guide utilisateur",
guideSubtitle: "Guides étape par étape pour chaque partie d’AssetWRX.",
openGuideA11y: "Ouvrir le guide de l'utilisateur",
},
pushNotificationPrefs: {
  productTitle: "Nouveautés du produit",
  productBody: "Réponses à vos demandes de fonctionnalité et nouvelles des idées pour lesquelles vous avez voté.",
  saveFailed: "Ce réglage n'a pas été enregistré. Vérifiez votre connexion et réessayez.",
  permission: {
    onBody: "Choisissez ci-dessous les alertes que vous recevez.",
    onTitle: "Les notifications sont activées sur ce téléphone",
    openSettings: "Ouvrir les réglages",
    blockedBody: "Ce téléphone n'autorise pas AssetWRX à envoyer des alertes. Activez-les dans les Réglages du téléphone, puis revenez.",
    blockedTitle: "Les notifications sont désactivées pour AssetWRX",
    askAction: "Activer les notifications",
    askBody: "Nous vous prévenons quand un travail vous est attribué, quand quelqu'un répond ou quand une décision vous attend. Votre téléphone vous demandera l'autorisation.",
    askTitle: "Recevez les alertes sur ce téléphone",
  },
assignmentTitle: "Assigné à moi",
assignmentBody: "Interventions et inspections qui vous sont attribuées, invitations de sous-traitants et travaux attribués.",
messageTitle: "Messages",
messageBody: "Réponses aux interventions, rapports partagés avec vous, et vos rapports Asset 360 et Site 360 quand ils sont prêts.",
approvalTitle: "Approbations et demandes",
approvalBody: "Nouvelles demandes, devis soumis, réalisations et demandes d'accès aux rapports en attente de votre décision.",
cardTitle: "Notifications push",
hintUnsupported: "Les notifications push sont envoyées à l’application mobile AssetWRX. Ces paramètres s’appliquent à votre téléphone.",
hintLoading: "Chargement de vos paramètres…",
hintDefault: "Choisissez ce qui atteint votre téléphone. Quoi qu'il en soit, tout apparaît toujours dans votre boîte de réception dans l'application.",
saveError: "Impossible d'enregistrer : {{error}}",
quietHoursTitle: "Heures calmes",
quietHoursBody: "Aucune notification push n’est envoyée pendant cette plage horaire. Les notifications arrivent toujours dans votre boîte de réception de l’application{{suffix}}.",
fromLabel: "À partir de",
toLabel: "À",
androidChannelNote: "Chaque catégorie possède son propre canal de notification Android, vous pouvez donc également régler le son et la priorité par catégorie dans les paramètres système.",
},
personal: {
notSet: "Non défini",
personalMode: "Mode personnel",
roleInCurrentContext: "Rôle dans le contexte actuel",
roleUnavailable: "Rôle indisponible",
languageNotSet: "Non défini (défaut espace de travail, puis appareil)",
timezoneNotSet: "Non défini (défaut espace de travail, puis appareil)",
languageHelper: "Laisser vide pour le défaut de l’espace de travail, puis la langue de l’appareil si prise en charge, puis anglais (États-Unis).",
timezoneHelper: "Laisser vide pour le fuseau de l’espace de travail, puis celui de l’appareil, puis UTC.",
effectiveLanguage: "Langue effective",
effectiveTimezone: "Fuseau horaire effectif",
localeMoved: "La langue et le fuseau horaire sont dans Préférences",
localeMovedA11y: "Ouvrir Préférences pour changer la langue et le fuseau horaire",
sectionTitle: "Informations personnelles",
sectionSubtitle: "Nom, coordonnées et bio.",
photoTitle: "Photo de profil",
photoSubtitle: "Votre photo apparaît dans la navigation, les vues d'équipe et l'activité. Elle est distincte du logo de l'espace de travail ou des rapports.",
edit: "Modifier",
fullName: "Nom complet",
displayName: "Nom affiché",
phone: "Téléphone",
language: "Langue",
timezone: "Fuseau horaire",
email: "E-mail",
bio: "Bio",
shortBio: "Bio courte",
editTitle: "Modifier le profil",
fieldDisplayName: "Nom affiché",
placeholderDisplayName: "Comment vous souhaitez apparaître",
fieldFirstName: "Prénom",
placeholderFirstName: "Prénom",
fieldLastName: "Nom",
placeholderLastName: "Nom",
fieldJobTitle: "Poste",
placeholderJobTitle: "Poste",
langA11y: "Langue",
tzA11y: "Fuseau horaire",
bioPlaceholder: "Courte description de votre profil",
emailReadOnlyHint: "Pour changer votre e-mail, allez dans Compte → Sécurité.",
cancel: "Annuler",
saveProfile: "Enregistrer le profil",
pickerLanguageTitle: "Langue",
pickerTimezoneTitle: "Fuseau horaire",
searchLanguage: "Rechercher une langue ou un code",
searchTimezone: "Rechercher un fuseau",
errorInvalidPhone: "Saisissez un numéro de téléphone valide.",
saveSuccessTitle: "Enregistré",
saveSuccessBody: "Votre profil a été mis à jour.",
saveErrorGeneric: "Impossible d’enregistrer le profil.",
phoneNumberLabel: "Numéro de téléphone",
countryCallingCodeA11y: "Indicatif pays",
countryCallingCodeHint: "Ouvre la liste des pays",
nationalNumberPlaceholder: "Numéro national",
nationalNumberA11y: "Numéro national",
countryRegionTitle: "Pays ou région",
searchCountry: "Rechercher un pays ou un code",
},
overview: {
  tileIndustryPacksSubtitle: "Types d'actifs, listes de contrôle et plans prêts à l'emploi",
  tileIndustryPacksTitle: "Packs sectoriels",
  tileAssetTypesTitle: "Types d’actifs",
  tileAssetTypesSubtitle: "Vos propres types d’actifs et de lieux, et les détails que chacun demande",
changePhoto: "Changer la photo",
uploadPhoto: "Téléverser une photo",
remove: "Supprimer",
noJobTitle: "Pas encore de poste",
profileCompleteness: "Complétude du profil",
memberSince: "Membre depuis",
recentMember: "Inscription récente",
moreSection: "Plus",
moreSubtitle: "Espace de travail, préférences et session.",
personalSection: "Personnel",
workspaceSection: "Espace de travail",
sessionSection: "Session",
workspace: "Espace de travail",
workspaceSubtitle: "Contexte, valeurs par défaut et image de marque des rapports.",
preferences: "Préférences",
help: "Aide",
securitySection: "Sécurité et confidentialité",
privacyData: "Confidentialité et données",
consentHistory: "Historique des consentements",
exportData: "Exporter mes données",
deleteAccount: "Supprimer le compte",
signOut: "Se déconnecter",
signOutTitle: "Se déconnecter",
signOutConfirm: "Voulez-vous vraiment vous déconnecter ?",
signOutCancel: "Annuler",
signOutAction: "Se déconnecter",
signOutPendingNote: "Votre travail en attente reste sur cet appareil lorsque vous vous déconnectez. Vous pouvez vérifier la synchronisation et résoudre les erreurs avant de quitter.",
reviewPendingWrites: "Voir les modifications en attente d'envoi",
signOutErrorTitle: "Impossible de terminer la déconnexion",
signOutErrorBody: "Vos modifications enregistrées ont été conservées. Veuillez réessayer.",
workspaceTypeMember: "Membre",
workspaceTypeContractor: "Prestataire",
workspaceTypeRecipient: "Destinataire",
teamsCount_one: "{{count}} équipe",
teamsCount_other: "{{count}} équipes",
kpiUsersLabel: "Utilisateurs",
kpiUsersHint: "Dans cet espace de travail",
kpiAssetsLabel: "Actifs",
kpiAssetsHint: "Total de l'espace de travail",
kpiInspectionsLabel: "Inspections",
kpiInspectionsHint: "Tous les enregistrements",
kpiJobsLabel: "Interventions",
kpiJobsOpenHint_one: "{{count}} ouverte",
kpiJobsOpenHint_many: "{{count}} ouvertes",
kpiJobsOpenHint_other: "{{count}} ouvertes",
kpiCreditsLabel: "Crédits",
kpiCreditsHint: "Solde disponible",
creditsUnlimited: "Illimité",
groupSettingsA11y_one: "{{title}}, {{count}} paramètre. {{action}}.",
groupSettingsA11y_many: "{{title}}, {{count}} paramètres. {{action}}.",
groupSettingsA11y_other: "{{title}}, {{count}} paramètres. {{action}}.",
groupExpandAction: "Développer",
groupCollapseAction: "Réduire",
groupYouTitle: "Vous",
groupPlanTitle: "Offre et outils",
tileOrganizationTitle: "Organisation",
tileOrganizationSubtitleAdmin: "Logo de l'espace de travail, profil de l'entreprise et informations juridiques",
tileOrganizationSubtitleMember: "Afficher le logo de l'espace de travail, le profil de l'entreprise et les informations juridiques",
tileTeamsTitle: "Équipes et invitations",
tileTeamsSubtitleAdmin: "Membres de l’espace de travail, rôles et invitations",
tileTeamsSubtitleMember: "Afficher les membres de l’espace de travail, les rôles et vos invitations",
tileDefaultsTitle: "Paramètres régionaux par défaut",
tileDefaultsSubtitle: "Devise, langue, fuseau horaire et méthodes de partage",
tileBrandingTitle: "Image de marque des rapports",
tileBrandingSubtitleAdmin: "Logo et informations d'exportation des PDF et partages (distincts de l'espace de travail)",
tileBrandingSubtitleMember: "Afficher le logo PDF/partage et les détails d'exportation",
tileIntegrationsTitle: "Intégrations",
tileIntegrationsSubtitle: "Connecter d'autres systèmes et importer des données",
tileTemplatesTitle: "Listes de contrôle",
tileTemplatesSubtitle: "Plans d’inspection et d'intervention",
tileAiTitle: "IA",
tileAiSubtitle: "Utilisation, automatisations, audit",
tileAssistantActivityTitle: "Activité de l'assistant",
tileAssistantActivitySubtitle: "Modifications faites via l'assistant",
tileYourPlanTitle: "Forfait {{plan}}",
tileYourPlanTitleLimit_one: "Forfait {{plan}} · {{owned}} actif sur {{count}}",
tileYourPlanTitleLimit_many: "Forfait {{plan}} · {{owned}} actifs sur {{count}}",
tileYourPlanTitleLimit_other: "Forfait {{plan}} · {{owned}} actifs sur {{count}}",
tileYourPlanTitleUnknown: "Votre forfait",
tileYourPlanSubtitle: "Voir les forfaits et ce que chacun inclut",
tileBillingTitle: "Facturation",
tileBillingSubtitleAdmin: "Forfait, crédits, factures",
tileBillingSubtitleMember: "Afficher le forfait et l'utilisation du crédit",
tileGuideTitle: "Guide utilisateur",
tileGuideSubtitle: "Guides étape par étape pour chaque partie d'AssetWRX",
tileProfileTitle: "Profil",
tileProfileSubtitle: "Nom, photo, contact",
tilePreferencesSubtitle: "Langue, apparence et alertes du téléphone",
tileSecurityTitle: "Sécurité",
tileSecuritySubtitle: "E-mail, mot de passe et double authentification",
tilePrivacyTitle: "Confidentialité",
tilePrivacySubtitle: "Vos données, nos e-mails, suppression du compte",
tileFeaturesTitle: "Fonctionnalités",
tileFeaturesSubtitle: "Ce qui est activé, désactivé ou verrouillé dans cet espace",
tileDiagnosticsTitle: "Diagnostics",
tileDiagnosticsSubtitle: "Version, connexion et état de synchronisation pour le support",
tileAboutTitle: "À propos",
tileAboutSubtitle: "Version et build",
groupAppTitle: "Application",
tileHelpTitle: "Aide",
groupAdvancedTitle: "Avancé",
tileNotificationsTitle: "Notifications",
tileNotificationsSubtitle: "E-mails et alertes que vous recevez",
tileBrandingDefaultsTitle: "Image de marque et valeurs par défaut",
tileBrandingDefaultsSubtitle: "Organisation, image de marque, valeurs régionales",
tileApiExplorerTitle: "Explorateur API",
tileApiExplorerSubtitle: "Essayez l’API publique avec vos clés",
tileHandbookTitle: "Guide d’intégration",
tileHandbookSubtitle: "Guides pour connecter et automatiser AssetWRX",
tileHelpSubtitle: "Comment fonctionne AssetWRX et où obtenir de l'aide",
teamsCount_many: "{{count}} équipes",
},
tabs: {
summary: "Résumé",
personal: "Personnel",
profilePagesA11y: "Pages des paramètres personnels",
},
accountScreen: {
title: "Paramètres du compte",
subtitleOverview: "Gérez votre profil, votre espace de travail, la facturation et les intégrations.",
subtitleOverviewPersonalOnly: "Votre profil, vos préférences, la sécurité et la confidentialité.",
subtitlePersonal: "Votre nom, vos coordonnées et votre photo",
subtitleWorkspace: "Profil de l’espace de travail, équipe, intégrations et facturation",
},
accountScope: {
areasA11y: "Zones des paramètres du compte",
userDetails: "Personnel",
userDetailsHint: "Profil, préférences et aide",
userDetailsTabA11y: "Paramètres personnels",
workspace: "Espace de travail",
workspaceHint: "Organisation, équipe et administration",
workspaceTabA11y: "Paramètres de l’espace de travail",
},
preferences: {
title: "Préférences",
subtitle: "Paramètres qui ne s'appliquent qu'à vous.",
localeTitle: "Langue et région",
localeHint: "Comment les dates, heures et textes vous sont présentés. Ces réglages suivent votre compte et s'appliquent donc sur chaque appareil où vous vous connectez.",
localeLanguage: "Langue",
localeTimezone: "Fuseau horaire",
localeLanguageA11y: "Changer la langue",
localeTimezoneA11y: "Changer le fuseau horaire",
localeEffectiveLanguage: "Actuellement en {{value}}",
localeEffectiveTimezone: "Actuellement sur {{value}}",
localeSaveError: "Impossible d'enregistrer votre langue et votre fuseau horaire.",
notificationsTitle: "Notifications",
pushNotifications: "Notifications push",
pushNotificationsHint: "Activez les alertes et mises à jour pour les vérifications d'inspection, les interventions et les rappels.",
haptics: "Retour haptique",
hapticsHint: "Une légère vibration dans la main lorsque vous terminez, enregistrez ou sélectionnez quelque chose.",
appearanceTitle: "Apparence",
appearanceHint: "Choisit si les écrans utilisent des surfaces claires ou sombres sur cet appareil. Suivre le système reprend le réglage de votre téléphone ou ordinateur.",
appearanceLight: "Clair",
appearanceDark: "Sombre",
appearanceSystem: "Suivre le système",
densityComfy: "Confortable",
densityComfyHint: "Plus d'espace",
densityCompact: "Compacte",
densityCompactHint: "Équilibré",
densityDense: "Dense",
densityDenseHint: "Un maximum à l'écran",
textSizeDefault: "Par défaut",
textSizeLarge: "Grande",
textSizeExtraLarge: "Très grande",
privacyTitle: "Confidentialité et données",
privacyHint: "Gérez vos données personnelles et votre compte.",
privacyOpenA11y: "Ouvrir Confidentialité et données",
deleteAccount: "Supprimer le compte",
deleteAccountHint: "Supprimez définitivement votre compte et vos données personnelles.",
textSizeTitle: "Taille du texte",
textSizeHint: "Rendre le texte plus facile à lire dans l'application. Cela s'applique partout et fonctionne avec le paramètre de taille de texte de votre appareil.",
textSizeA11y: "Taille du texte {{label}}",
densityTitle: "Densité d'affichage",
densityHint: "Quantité d'informations regroupées sur chaque écran. S'applique partout.",
densityA11y: "Densité d'affichage {{label}}",
privacyDataTitle: "Confidentialité et données",
privacyDataHint: "Politique de confidentialité, Conditions, Exportation, Préférences de communication, Historique des consentements, Supprimer le compte",
},
deleteAccount: {
  ownerHandOver: "Transférer la propriété",
  ownerImpact: "Vous êtes propriétaire de cet espace de travail et d'autres personnes y travaillent. Elles perdront l'accès quand vous supprimerez votre compte. Pour le leur laisser, transférez d'abord la propriété à quelqu'un d'autre.",
  contactSupport: "Contacter l'assistance AssetWRX",
warningTitle: "Cette action supprime définitivement votre compte",
warningBody: "La suppression de votre compte est irréversible. Une fois la période de récupération écoulée, vos données ne pourront plus être restaurées.",
consequencesTitle: "Ce qui sera supprimé",
consInspections: "Toutes les inspections que vous avez créées et leurs rapports",
consAssets: "Vos actifs et leur historique",
consMedia: "Photos, documents et autres fichiers que vous avez importés",
consTeams: "Vos adhésions aux équipes et l’accès aux espaces partagés",
consBilling: "Les abonnements actifs sont annulés et la facturation s’arrête",
recoveryBody: "Les espaces de travail dont vous êtes propriétaire sont conservés {{days}} jours, puis supprimés définitivement. Pour demander à les récupérer pendant ce délai, contactez l'assistance AssetWRX. Vos informations personnelles sont supprimées immédiatement.",
offlineBanner: "Vous êtes hors ligne. Reconnectez-vous à Internet pour supprimer votre compte.",
confirmLabel: "Saisissez {{token}} pour confirmer",
confirmHelper: "Saisissez {{token}} exactement comme indiqué pour activer le bouton de suppression.",
passwordLabel: "Confirmez votre mot de passe",
passwordHelper: "Nécessaire si vous vous connectez avec un mot de passe. Laissez vide si vous vous connectez avec Google, Apple ou Microsoft.",
passwordPlaceholder: "Votre mot de passe",
reauthError: "Veuillez ressaisir votre mot de passe pour confirmer votre identité.",
genericError: "La suppression du compte n’a pas pu aboutir. Veuillez réessayer.",
deleteButton: "Supprimer mon compte",
deletingStatus: "Suppression de votre compte…",
modalTitle: "Supprimer définitivement le compte ?",
modalBody: "Cette action est irréversible. Vos données personnelles sont anonymisées maintenant et les espaces dont vous êtes le seul propriétaire sont supprimés après la période de récupération.",
modalConfirm: "Supprimer définitivement",
modalCancel: "Conserver mon compte",
successTitle: "Votre compte est en cours de suppression",
successBody: "Vous avez été déconnecté. Nous avons commencé à supprimer vos données et annulé les abonnements actifs. Vous changez d’avis ? Contactez l’assistance AssetWRX dans les 30 jours.",
complianceNote: "Vous pouvez demander la suppression de votre compte à tout moment dans l’application, comme l’exigent l’App Store et Google Play.",
cancel: "Annuler",
},
featureRequests: {
  editFirst: "Modifier d'abord",
  helpRowTitle: "Demander une fonctionnalité",
  helpRowSubtitle: "Dites-nous ce qui rendrait AssetWRX plus utile pour vous.",
  myRequestsTitle: "Vos demandes",
  myRequestsSubtitle: "Ce que vous avez demandé, et où ça en est.",
  myRequestsRowSubtitle_one: "{{count}} demande envoyée",
  myRequestsRowSubtitle_many: "{{count}} demandes envoyées",
  myRequestsRowSubtitle_other: "{{count}} demandes envoyées",
  myRequestsEmpty: "Vous n'avez encore demandé aucune fonctionnalité.",
  ideasTitle: "Idées à l'étude",
  ideasSubtitle: "Votez pour celles que vous voulez. Nous vous dirons quand elles avancent.",
  ideasRowSubtitle: "Votez pour la suite.",
  ideasEmpty: "Aucune idée n'est soumise au vote pour le moment.",
  ideasFooter: "Les idées ici sont rédigées par l'équipe AssetWRX. Vos propres demandes restent privées.",
  loadFailed: "Le chargement a échoué. Vérifiez votre connexion et tirez vers le bas pour réessayer.",
  sentOn: "Envoyée le {{date}} · {{category}}",
  mergedNote: "Quelqu'un a demandé la même chose, nous avons donc regroupé votre demande avec la sienne. Vous serez prévenu quand elle avance.",
  replyFromTeam: "Réponse de l'équipe AssetWRX",
  seeWhatsNew: "Voir les nouveautés : {{title}}",
  onIdeasBoard: "La voir parmi les idées",
  vote: "Je le veux",
  voted: "Voté",
  voteA11y: "Voter pour {{title}}",
  unvoteA11y: "Retirer votre vote pour {{title}}",
  voteCount_one: "{{count}} voix",
  voteCount_many: "{{count}} voix",
  voteCount_other: "{{count}} voix",
  voteFailedTitle: "Votre vote n'a pas été enregistré",
  voteFailedBody: "Vérifiez votre connexion et réessayez.",
  status: {
    sent: "Envoyée",
    under_review: "En cours d'examen",
    planned: "Prévue",
    in_progress: "En développement",
    shipped: "Disponible dans l'app",
    not_planned: "Pas prévue pour l'instant",
  },
  ideaStatus: {
    considering: "À l'étude",
    planned: "Prévue",
    in_progress: "En développement",
    shipped: "Disponible dans l'app",
  },
  category: {
    assets: "Actifs et lieux",
    inspections: "Inspections et checklists",
    work: "Interventions et travaux",
    schedules: "Plannings",
    reports: "Rapports",
    team: "Équipe et prestataires",
    integrations: "Intégrations et API",
    other: "Autre chose",
  },
  importance: {
    nice_to_have: "Ce serait bien",
    saves_time: "Me ferait gagner du temps",
    blocking: "Je ne peux pas travailler sans",
  },
  errors: {
    daily_limit: "Vous avez envoyé 5 demandes aujourd'hui. Envoyez les autres demain.",
    workspace_limit: "Votre espace de travail a envoyé 20 demandes aujourd'hui. Réessayez demain.",
    blocked: "Les demandes de fonctionnalité sont désactivées pour votre compte. Contactez le support si c'est une erreur.",
    incomplete: "Ajoutez un titre court et expliquez ce dont vous avez besoin.",
    screenshot: "Une capture d'écran n'a pas été envoyée. Retirez-la ou réessayez.",
    failed: "Votre demande n'a pas été envoyée. Vérifiez votre connexion et réessayez.",
  },
  form: {
    title: "Demander une fonctionnalité",
    subtitle: "Dites-nous ce dont vous avez besoin. L'équipe AssetWRX lit chaque demande.",
    titleLabel: "Que souhaitez-vous ?",
    titlePlaceholder: "Par exemple : imprimer une étiquette QR pour chaque pièce",
    titleRequired: "Ajoutez un titre court.",
    descriptionLabel: "En quoi cela vous aiderait-il ?",
    descriptionPlaceholder: "Qu'essayez-vous de faire, et qu'est-ce qui vous en empêche aujourd'hui ?",
    descriptionRequired: "Expliquez en quelques mots ce dont vous avez besoin.",
    categoryLabel: "Quelle partie de l'app ?",
    categoryRequired: "Choisissez la partie de l'app concernée.",
    importanceLabel: "Quelle importance ?",
    screenshotsLabel: "Captures d'écran (facultatif)",
    screenshotsHint: "Jusqu'à 3. N'y montrez pas de données personnelles ou de clients.",
    addScreenshot: "Ajouter une capture d'écran",
    addScreenshotShort: "Ajouter",
    removeScreenshot: "Retirer la capture d'écran",
    photoPermissionTitle: "Autoriser l'accès aux photos",
    photoPermissionBody: "Pour ajouter une capture d'écran, autorisez AssetWRX à voir vos photos dans les Réglages de votre téléphone.",
    similarTitle: "Vous avez déjà demandé quelque chose de proche",
    similarHint: "Si c'est la même chose, suivez-la dans Vos demandes au lieu de la renvoyer.",
    detailsTitle: "Envoyé avec votre demande",
    detailsHint: "Cela nous aide à comprendre où vous étiez. Rien d'autre de votre espace de travail n'est envoyé.",
    detailApp: "Version de l'app",
    detailUpdate: "Mise à jour",
    detailDevice: "Appareil",
    detailLanguage: "Langue",
    detailScreen: "Écran",
    detailWorkspace: "Espace de travail",
    detailWorkspaceValue: "Le nom et l'offre de votre espace de travail",
    send: "Envoyer la demande",
    failedTitle: "Non envoyée",
    sentTitle: "Merci, c'est reçu",
    sentBody: "Nous lisons chaque demande. Vous recevrez une notification quand son statut change ou quand nous répondons.",
    seeYourRequests: "Voir vos demandes",
    done: "Terminé",
  },
},
};
